// extracted by mini-css-extract-plugin
export default {"rightClick_container":"RightClickMenu_rightClick_container__uHknn","disabled_btn":"RightClickMenu_disabled_btn__Xc8Gp"};